import React, { useEffect, useRef } from 'react'
import styled from '@emotion/styled'
import { useTranslation } from 'next-i18next'
import PaymentSelectorItem from './payment-selector-item'
import PaymentSelectorSkeleton from './payment-selector-skeleton'
import { DEFAULT_THEME_COLORS, DEFAULT_BORDER_STYLES } from 'css/theme'
import { usePaymentMethodSelection } from '../hooks/use-payment-method-selection'

export const PaymentMethodSelector = () => {
  const initialFocusRef = useRef<HTMLLabelElement>(null)
  const { t } = useTranslation()

  const { selectedPaymentMethod, activePaymentMethodConfigs, onSelect, isLoading } =
    usePaymentMethodSelection()

  useEffect(() => {
    if (initialFocusRef.current) {
      initialFocusRef.current.focus()
    }
  }, [])

  const PaymentMethodLabels: { [key: string]: string } = {
    card: t('paymentMethods.creditCard.label', 'Card'),
    bank_transfer: t('paymentMethods.bankTransfer.label', 'Bank transfer'),
  }

  if (isLoading) {
    return <PaymentSelectorSkeleton />
  }

  return (
    <Wrapper>
      {activePaymentMethodConfigs.map((config, index) => (
        <PaymentSelectorItem
          ref={index === 0 ? initialFocusRef : null}
          key={config.key}
          label={config.labelKey ? PaymentMethodLabels[config.labelKey] : config.label}
          icon={config.icon}
          value={config.key}
          onChange={onSelect}
          checked={config.key === selectedPaymentMethod}
          radioGroupName="payment_method"
          secondaryItems={config.secondaryItems ? <config.secondaryItems /> : null}
          accordionContent={config.accordionContent ? <config.accordionContent /> : null}
        />
      ))}
    </Wrapper>
  )
}

const Wrapper = styled.fieldset({
  margin: 0,
  padding: 0,
  width: '100%',
  overflow: 'hidden',
  border: `1px solid ${DEFAULT_THEME_COLORS['--theme-color--neutral-90']}`,
  borderRadius: DEFAULT_BORDER_STYLES['--theme--border-radius-lg'],
  'label:first-child': {
    borderTopLeftRadius: DEFAULT_BORDER_STYLES['--theme--border-radius-lg'],
    borderTopRightRadius: DEFAULT_BORDER_STYLES['--theme--border-radius-lg'],
  },
  'label:last-child': {
    borderBottom: 'none',
    borderEndStartRadius: DEFAULT_BORDER_STYLES['--theme--border-radius-lg'],
    borderEndEndRadius: DEFAULT_BORDER_STYLES['--theme--border-radius-lg'],
  },
})
